module.exports = __webpack_public_path__ + "img/kou_01.a4b533ee.png";